import proofsSliders from './sliders/_proofs';

$(document).ready(() => {

  proofsSliders();

});
